import React from 'react';
import { Button, Tooltip } from 'antd';
import { EditOutlined } from '@ant-design/icons';

const ActEditUser = ({ userInfo, setUserInfo, setOpenEdit }) => {
  const handleEdit = () => {
    setUserInfo(userInfo);
    setOpenEdit(true);
  };

  return (
    <Tooltip title="Chỉnh sửa người dùng">
      <Button
        type="primary"
        icon={<EditOutlined />}
        size="small"
        onClick={handleEdit}
        style={{
          marginRight: 8,
          backgroundColor: '#0284c7',
          borderColor: '#0284c7'
        }}
      />
    </Tooltip>
  );
};

export default ActEditUser;
